import Vue from 'vue';
import Router from 'vue-router';
import { getAppData } from 'optinmonster-js-library/src/vue/utils';
import { mapTo } from 'optinmonster-js-library/src/utils';
import parser from './parser';
import navGuards from './navGuards';
import routes from './routes';

Vue.use(Router);

// Swallow NavigationDuplicated/NavigationCancelled errors introduced in 3.1.0
// when push/replace callers don't provide their own rejection handlers.
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) {
		return originalPush.call(this, location, onResolve, onReject);
	}
	return originalPush.call(this, location).catch((err) => {
		if (Router.isNavigationFailure(err)) {
			return err;
		}
		return Promise.reject(err);
	});
};

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location, onResolve, onReject) {
	if (onResolve || onReject) {
		return originalReplace.call(this, location, onResolve, onReject);
	}
	return originalReplace.call(this, location).catch((err) => {
		if (Router.isNavigationFailure(err)) {
			return err;
		}
		return Promise.reject(err);
	});
};

// Instantiate the router with our routes.
const router = navGuards.set(
	mapTo(
		parser,
		new Router({
			mode: 'history',
			base: getAppData('adminPath', '/wp-admin/admin.php'),
			routes,
			scrollBehavior(to, from, savedPosition) {
				if (savedPosition) {
					// savedPosition is only available for popstate navigations.
					return savedPosition;
				}

				if (to.hash) {
					return new Promise((resolve) => {
						// wait for the in/out transition to complete.
						this.app.$root.$once('triggerScroll', () => {
							// Ensure transition is fully complete.
							return setTimeout(() => resolve({ selector: to.hash }), 20);
						});
					});
				}

				return false;
			},
		})
	)
);

const resolve = router.resolve;
router.resolve = function fixAdminLinks(...args) {
	const resolved = resolve.call(router, ...args);

	// Now fix the trailing slashes Vue adds to .php links.
	// See: https://github.com/awesomemotive/optin-monster-wp-api/issues/433
	resolved.href = resolved.href.replace('.php/', '.php');

	return resolved;
};

export default router;
